/* Twisted Suds & Company: show only in-stock scent/shape combinations. Draft theme only. */
(function () {
  if (window.__twistedSudsVariantFilterInstalled) return;
  window.__twistedSudsVariantFilterInstalled = true;

  var pickerSelector = 'variant-selects[data-product-handle="twisted-suds-bath-bombs"], variant-selects[data-product-handle="twisted-suds-shower-steamers"], variant-selects[data-product-handle="twisted-suds-whipped-sugar-scrub"], variant-selects[data-product-handle="twisted-suds-classic-sugar-scrubs"], variant-selects[data-product-handle="twisted-suds-solid-lotion-bars"], variant-selects[data-product-handle="magnesium-moon-2-0"], variant-selects[data-product-handle="bathroom-accessories"], variant-selects[data-product-handle="kitchen-accessories"]';
  var states = new WeakMap();

  function readSelected(group) {
    if (group.select) return group.select.value;
    var item = group.radios.find(function (entry) { return entry.input.checked; });
    return item ? item.input.value : null;
  }

  function readState(picker) {
    if (states.has(picker)) return states.get(picker);
    var script = picker.querySelector('[data-suds-variant-stock]');
    if (!script) return null;

    var variants;
    try {
      variants = JSON.parse(script.textContent).filter(function (v) { return v.inStock; });
    } catch (error) {
      console.warn('Twisted Suds variant stock data could not be read', error);
      return null;
    }
    if (!variants.length) return null;

    var wrappers = Array.from(picker.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown'));
    if (wrappers.length < 1 || wrappers.length > 2) return null;
    var groups = wrappers.map(function (wrapper) {
      var select = wrapper.querySelector('select');
      if (select) {
        return {
          select: select,
          originals: Array.from(select.options).map(function (item) { return item.cloneNode(true); })
        };
      }
      var radios = Array.from(wrapper.querySelectorAll('input[type="radio"]')).map(function (input) {
        var label = Array.from(wrapper.querySelectorAll('label')).find(function (item) {
          return item.htmlFor === input.id;
        });
        return { input: input, label: label, labelDisplay: label ? label.style.display : '' };
      });
      return { radios: radios };
    });
    var state = { variants: variants, groups: groups };
    states.set(picker, state);
    return state;
  }

  function filterGroup(group, allowed) {
    var previous = readSelected(group);
    if (group.select) {
      var permitted = group.originals.filter(function (option) { return allowed.has(option.value); });
      var selected = allowed.has(previous) ? previous : permitted.length ? permitted[0].value : '';
      var currentOptions = Array.from(group.select.options);
      var identical = permitted.length === currentOptions.length && permitted.every(function (item, index) {
        return currentOptions[index].value === item.value;
      });
      if (!identical) {
        group.select.replaceChildren.apply(group.select, permitted.map(function (option) {
          return option.cloneNode(true);
        }));
      }
      group.select.value = selected;
      Array.from(group.select.options).forEach(function (option) {
        option.selected = option.value === selected;
        if (option.selected) option.setAttribute('selected', 'selected');
        else option.removeAttribute('selected');
      });
    } else {
      var eligible = group.radios.filter(function (item) { return allowed.has(item.input.value); });
      var selectedRadio = eligible.find(function (item) { return item.input.value === previous; }) || eligible[0];
      group.radios.forEach(function (item) {
        var show = allowed.has(item.input.value);
        item.input.disabled = !show;
        item.input.hidden = !show;
        if (item.label) {
          item.label.hidden = !show;
          item.label.style.display = show ? item.labelDisplay : 'none';
        }
        item.input.checked = item === selectedRadio;
      });
    }
    return previous !== readSelected(group);
  }

  function refresh(picker) {
    var state = readState(picker);
    if (!state) return false;
    var availableFirst = new Set(state.variants.map(function (v) { return v.first; }));
    var firstChanged = filterGroup(state.groups[0], availableFirst);
    var secondChanged = false;
    if (state.groups.length > 1) {
      var chosenFirst = readSelected(state.groups[0]);
      var availableSecond = new Set(state.variants.filter(function (v) {
        return v.first === chosenFirst;
      }).map(function (v) { return v.second; }));
      secondChanged = filterGroup(state.groups[1], availableSecond);
    }
    return firstChanged || secondChanged;
  }

  function refreshAll(notifyShopify) {
    document.querySelectorAll(pickerSelector).forEach(function (picker) {
      if (!refresh(picker) || !notifyShopify) return;
      var state = states.get(picker);
      var group = state.groups[state.groups.length - 1];
      var input = group.select || (group.radios.find(function (item) {
        return item.input.checked;
      }) || {}).input;
      if (input) input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Capture the change before Craft builds its variant request, so its requested
  // scent always belongs to the newly selected shape.
  document.addEventListener('change', function (event) {
    var picker = event.target.closest && event.target.closest(pickerSelector);
    if (picker) refresh(picker);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refreshAll(true); });
  } else {
    refreshAll(true);
  }

  document.addEventListener('product-info:loaded', function () { refreshAll(true); });
  document.addEventListener('shopify:section:load', function () { refreshAll(true); });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { refreshAll(true); });
  }
})();